export const ru = {
  LANGUAGES: {
    English: 'Английский',
    Russian: 'Русский',
    Ukrainian: 'Украинский',
    German: 'Немецкий',
  },
  PAGES: {
    CHAT_HISTORY: {
      YOUR_PREVIOUS_CONVERSATION: 'Ваши предыдущие разговоры',
      SEARCH_BY_NAME: 'Поиск по названию',
      PLACEHOLDER_TITLE: 'По вашему запросу ничего не найдено',
      PLACEHOLDER_TEXT: 'Попробуйте изменить параметры поиска',
      EMPTY: {
        TITLE: 'У вас пока нет активных чатов',
        TEXT: 'Выберите приключение из десятков тысяч или создайте свое',
        CREATE_CHATBOT: 'Создать чат-бота',
        GO_TO_CATALOG: 'Перейти в каталог',
      },
    },
    SUBSCRIBE: {
      SUBSCRIBE: 'Подписка',
      PICK_THE_PLAN: 'Выберите план или купите токены',
      UPGRADE_YOUR_EXPERIENCE: 'Улучшите свой опыт и раскройте воображение с премиум-функциями',
      BUY_TOKENS: 'Купить токены',
      APPLY: 'Применить',
      PROMOTIONAL_CODE: 'Промокод',
      COMPARE_CAICHAT_FEATURE: 'Сравните функции CAICHAT',
      NO_ADS: 'Без рекламы',
      SKIP_QUEUES: 'Без очередей',
      CONTEXTUAL_MEMORY_4K: 'Контекстная память до 4K токенов (примерно 42 сообщения)',
      ACCESS_MEMORY_MANAGER: 'Доступ к менеджеру памяти',
      CUSTOM_PERSONAS_10: 'До 10 пользовательских персон',
      CONTEXTUAL_MEMORY_8K: 'Контекстная память до 8K токенов (примерно 84 сообщения)',
      SEMANTIC_MEMORY_2: 'Семантическая память 2.0: автоматическое сохранение и использование воспоминаний',
      EXTENDED_RESPONSES: 'Расширенные ответы до 300 токенов',
      IMAGE_GENERATION: 'Генерация изображений в диалоге',
      ACCESS_AI_MODELS: 'Доступ к дополнительным моделям ИИ',
      CUSTOM_PERSONAS_50: 'До 50 пользовательских персон',
      CONTEXTUAL_MEMORY_16K: 'Контекстная память до 16K токенов (примерно 168 сообщений)',
      PRIORITY_GENERATION: 'Приоритет в генерации ответов',
      ACCESS_ADVANCED_MODELS: 'Доступ к продвинутым моделям ИИ',
      IMAGE_GENERATION_ALL: 'Генерация изображений для всех персонажей, включая приватных',
      TEXT_TO_SPEECH: 'Функция преобразования текста в речь (голосовые ответы)',
      CUSTOM_PERSONAS_100: 'До 100 пользовательских персон',
    },
    MY_PROFILE: {
      BACK: 'Назад',
      MY_PROFILE: 'Мой профиль',
      SETTINGS: 'Настройки',
      LOG_OUT: 'Выйти',
      TITLE: 'Держитесь крепче!\nВаша персональная панель управления готовится!',
      TEXT: 'Наша команда усердно работает над тем, чтобы создать для вас максимально удобный личный кабинет.\nСкоро вы сможете просматривать подробную статистику, отслеживать расходы и доходы и многое другое.\nСледите за новостями!',
    },
    MY_PERSONAS: {
      PLACEHOLDER_1: 'У вас еще нет персон.',
      PLACEHOLDER_2: 'Создайте новую.',
      CREATE_PERSONA: 'Создать новую персону',
    },
    CREATE_PERSONA: {
      PERSONA: 'Персона',
      NAME_PLACEHOLDER: 'Пожалуйста, введите название вашей персоны',
      DESCRIPTION: 'Описание',
      DESCRIPTION_PLACEHOLDER: 'Как бы ваш персонаж описал себя?',
      DESCRIPTION_INFO: 'Используется только в ваших разговорах для предоставления контекста ИИ. Будьте лаконичны (1-2 предложения).',
      VISIBILITY: 'Видимость',
      PUBLIC: 'Публичная',
      PRIVATE: 'Приватная',
      CHECKBOX: 'Установить как персону по умолчанию',
      ALREADY_DEFAULT: 'Уже персона по умолчанию',
      NAME: 'Название',
      SUCCESSFULLY_CREATED: 'Персона успешно создана',
      SUCCESSFULLY_UPDATED: 'Персона успешно обновлена',
      NO_SPACE_FOR_NEW_PERSONAS: 'Вы не сможете создавать новых персон, пока не освободите место',
    },
    MY_CHATBOTS: {
      NO_CHATBOTS: 'Вы еще не создали ни одного чат-бота!',
      DO_IT_NOW: 'Сделайте это сейчас!',
    },
    CHARACTERS: {
      NO_CHARACTERS: 'По вашему запросу ничего не найдено',
      FILTERS: 'Попробуйте изменить параметры поиска или создайте собственного чатбота',
    },
    PUBLIC_PROFILE: {
      NO_CHATBOTS: 'У этого пользователя сейчас нет чатботов',
      TRY_LATTER: 'Попробуйте зайти позже',
    },
    FAVORITES: {
      NO_FAVORITES: 'У вас пока нет чатботов в избранном',
      GO_AND_ADD: 'Перейдите в каталог и добавьте чатботов в избранное, нажав на кнопку',
    },
    CHATBOT_CREATE: {
      UPLOADING: 'Загрузка',
      MODEL_AND_PROMPT: 'Выберите модель ИИ и системный промпт',
      IMPORT_CHATBOT: 'Импортировать чат-бота',
      CHATBOT_AVATAR: 'Аватар чат-бота',
      CHATBOT_NAME: 'Имя чат-бота',
      CHATBOT_DESCRIPTION: 'Описание чат-бота',
      UPLOAD_IMAGE_FOR_CHATBOT: 'Загрузить изображение для чат-бота',
      CREATE_CHATBOT: 'Создать чат-бота',
      START_CHAT: 'Начать чат',
      SAVE_CHANGES: 'Сохранить изменения',
      AGREEMENT_TEXT: 'Я прочитал и согласен с',
      COMMUNITY_GUIDELINES: 'Правилами сообщества',
      MESSAGE_COST: 'Стоимость сообщения',
      GENDER: 'Пол',
      VISIBILITY: 'Видимость',
      ADD_TAGS: 'Добавить теги',
      SEARCH_TAGS: 'Поиск тегов',
      NAME_PLACEHOLDER: 'Введите название чат-бота',
      DESCRIPTION_PLACEHOLDER:
        'Краткое описание чатбота, которое будет отображаться в каталоге и превью.<br><br>Это не повлияет на память или промпты.',
      CREATE_NEW_CHATBOT: 'Создать нового чат-бота',
      EDIT_EXISTING_CHATBOT: 'Редактировать существующего чат-бота',
      CHATBOT_PROFILE: 'Профиль чат-бота',
      GUIDE: 'Читать руководство',
      READ_CREATION_GUIDE: 'Прочитайте наше руководство по созданию чат-ботов',
      STATS_TITLE: 'Статистика',
      HAS_BEEN_STARTED: 'Было начато:',
      CHAT_TIME: 'Время чата:',
      USER_MESSAGES: 'Сообщений пользователя:',
      CHARACTER_MESSAGES: 'Сообщений персонажа:',
      USER_WORDS: 'Слов пользователя:',
      CHARACTER_WORDS: 'Слов персонажа:',
      FILL_REQUIRED_FIELDS: 'Необходимо заполнить обязательные поля!',
      MALE: 'Мужской',
      FEMALE: 'Женский',
      NON_BINARY: 'Небинарный',
      OTHER: 'Другой',
      NOT_SPECIFIED: 'Не указано',
      PUBLIC: 'Публичный',
      PRIVATE: 'Приватный',
      VISIBLE_TOOLTIP: 'Публичный - видимый всем \n \n Приватный - видимый только автору',
      AI_TOOLTIP:
        'ИИ модель: Программа, обученная понимать и генерировать текст как человек. \n \n Системный промпт: Скрытая инструкция, которая указывает ИИ, как он должен себя вести.',
      NO_ONLY_EMOJI: 'Имя не может состоять только из эмодзи',
      COST_DEPENDS: 'Стоимость зависит от различных параметров: Модель, Промпт, Приветствия, Сценарий.',
      PRICE_1_MESSAGE: 'Цена за 1 сообщение:',
      NOT_AVAILABLE: {
        TITLE: 'Это приватный чатбот',
        TEXT: 'Вы пытаетесь получить доступ к ссылке на чатбота, доступ к которому ограничен его автором. Вы не можете просматривать или взаимодействовать с этим чатботом.',
        GO_HOME: 'На главную страницу',
      },
      OTHER_CHATBOTS_BY_AUTHOR: 'Другие боты этого автора',
      SIMILAR_CHATBOTS: 'Похожие боты',
    },
  },
  MODALS: {
    MODEL_SETTINGS: {
      TITLE: 'Настройки модели',
      ADVANCED_SETTINGS: 'Расширенные настройки',
      APPLY_SETTINGS: 'Применить настройки',
    },
    GENERATE_IMAGE: {
      GENERATE_BACKGROUND: 'Сгенерировать фон',
      GENERATE_AVATAR: 'Сгенерировать аватар',
      ENTER_PROMPT: 'Введите подсказку для генерации изображения',
      AGE_ERROR: 'Запрос отклонен: требования безопасности. Персонажи младше 18 лет запрещены.',
    },
    CHATBOT_REMOVED: {
      TITLE: 'Чат-бот удалён',
      TEXT: 'Этот чат-бот был удалён автором или администратором. Начните общаться с другими ботами прямо сейчас.',
      GO_HOME: 'На главную',
    },
    WELCOME: {
      TITLE: 'Добро пожаловать',
      CAN_CHANGE: 'Вы можете изменить это в любое время',
      HOW_TO_ADDRESS: 'Как чат-бот будет обращаться к вам',
      AGE_AGREE: 'Я подтверждаю, что мне 18 лет или больше',
      BOUND_BY: 'Вы соглашаетесь быть связанными нашими',
    },
    ALLOW_NSFW_CONTENT: {
      TITLE: 'Доступ к NSFW-контенту',
      TEXT: 'Явная видимость должна быть включена в настройках вашей учетной записи. После включения вы сможете управлять отображением NSFW-контента прямо с главной страницы.',
      GO_TO_PROFILE: 'Перейти в профиль',
    },
    CHAT_DECRYPT: {
      TITLE: 'Этот чат защищён паролем',
      TEXT: 'Введите пароль для доступа к чату',
      ENCRYPT_PASSWORD: 'Пароль шифрования',
      CONFIRM_ENCRYPT_PASSWORD: 'Подтвердите пароль шифрования',
    },
    CHAT_ENCRYPT: {
      TITLE: 'Сквозное шифрование',
      NOT_ENCRYPTED: 'Ваш чат не зашифрован',
      ENCRYPTED: 'Ваш чат зашифрован',
      TEXT: 'Сообщения и чаты защищены сквозным шифрованием. Третьи лица, включая {{brand}}, не могут читать ваши сообщения.',
      ENTER_LABEL: 'Создайте пароль шифрования, если хотите включить шифрование для чата с чат-ботом.',
      ENABLE: 'Включить шифрование',
      DISABLE: 'Отключить шифрование',
    },
    CHARACTER_INFO: {
      CHOOSE_A_PERSONA: 'Выберите персонажа:',
      AI_MODEL_AND_A_SYSTEM_PROMPT: 'AI-модель и системная подсказка',
      TOOLTIP:
        'AI-модель: программа, обученная понимать и генерировать текст как человек.\nСистемная подсказка: скрытая инструкция, которая указывает ИИ, как себя вести.',
      TAGS: 'Теги',
      START_CHAT: 'Начать чат',
    },
    PASSWORD_RESET: {
      ENTER_NEW_PASSWORD: 'Введите новый пароль в поля ниже.',
      INVALID_URL: 'Недействительная ссылка. Пожалуйста, запросите сброс пароля снова.',
      APPLY_NEW_PASSWORD: 'Применить новый пароль',
      REQUEST_PASSWORD_RESET: 'Запросить сброс пароля',
    },
    IMAGES_GENERATION_SETTINGS: {
      IMAGES_TITLE: 'Изображения',
      NEGATIVE_PROMPT: 'Негативный промт',
      NEGATIVE_PROMPT_PLACEHOLDER: 'Напишите, что вы не хотите видеть на изображениях',
      STYLE_TITLE: 'Стиль',
      STYLE_ANIME: 'Аниме',
      UNI_STYLE: 'Свободный',
      STYLE_REALISTIC: 'Реализм',
      GENERATION_OF_NSFW: 'Генерация NSFW-изображений',
      GENERATION_OF_NSFW_TOOLTIP: 'Включите, если хотите видеть контент, не подходящий для несовершеннолетних.',
      GUIDANCE_SCORE: 'Коэффициент направленности',
      CREATIVE: 'Креативный',
      PRECISE: 'Точный',
      DISABLE: 'Отключить',
      ENABLE: 'Включить',
    },
    PROFILE_SETTINGS: {
      MY_ACCOUNT: {
        MY_ACCOUNT: 'Мой аккаунт',
        CHANGE_PERSONA: 'Сменить персонажа',
        DEFAULT_PERSONA: 'Персонаж по умолчанию',
        USERNAME: {
          USERNAME: 'Имя пользователя',
          PLACEHOLDER: 'Введите имя пользователя',
          ERROR: 'Имя пользователя может содержать только латинские буквы (a–z), цифры и дефисы',
          ERROR_LENGTH: 'Имя пользователя должно содержать от 3 до 20 символов.',
        },
        EMAIL: {
          EMAIL: 'Электронная почта',
          PLACEHOLDER: 'Введите вашу электронную почту',
          VERIFIED: 'Почта подтверждена',
          VERIFY: 'Подтвердить почту',
          NOT_VERIFIED: 'Почта не подтверждена',
        },
        EMAIL_VERIFICATION: {
          TITLE: 'Подтверждение почты',
          TEXT_1: 'На адрес отправлено письмо',
          TEXT_2: 'Пожалуйста, нажмите на ссылку в этом письме, чтобы завершить подтверждение.',
          NO_CODE: 'Не получили код?',
          RESEND: 'Отправить снова',
          SEC: 'сек',
          ERROR: 'Не удалось отправить письмо для подтверждения. {{error}}',
        },
        DATE_OF_BIRTH: 'Дата рождения',
        DATE_OF_BIRTH_ERROR: 'Минимальный возраст должен быть не менее 18 лет',
        DESCRIPTION: 'Описание',
        DESCRIPTION_PLACEHOLDER: 'Введите краткое описание здесь',
        SOCIALS: 'Соцсети',
        ADD_NEW: 'Добавить новую',
        SAVE: 'Сохранить',
        SUCCESS: 'Данные успешно сохранены!',
        FAIL: `Не удалось сохранить данные, {{error}}`,
      },
      PREFERENCES: {
        PREFERENCES: 'Настройки',
        THEME: {
          THEME: 'Тема',
          SYSTEM: 'Системная',
          LIGHT: 'Светлая',
          DARK: 'Темная',
        },
        NSFW: {
          TITLE: 'Показывать чат-ботов с изображениями или выражениями непристойного характера (NSFW)',
          ERROR: 'Вы не можете включить отображение контента NSFW. Подтвердите, что вам исполнилось 18 лет на ',
          LINK: 'вкладке «Мой аккаунт»',
        },
        NOTIFICATIONS: {
          SUCCESS: 'Настройки успешно применены!',
          FAIL: 'Не удалось применить настройки',
        },
      },
      SECURITY: {
        SECURITY: 'Безопасность',
        TWO_FACTOR: {
          TITLE: 'Двухфакторная аутентификация',
          DESCRIPTION: 'Двухфакторная аутентификация (2FA) обеспечивает более надежную защиту аккаунта.',
          DOWNLOAD: 'Загрузить Google Authenticator',
          APP_DESCRIPTION:
            'Google Authenticator — это независимый сервис от Google Inc., который защищает вашу учётную запись. После настройки вам потребуется подтвердить вход в приложение или вывод средств, используя пароль, сгенерированный Google Authenticator.',
          SCAN: 'Отсканируйте QR-код или загрузите из магазина приложений.',
          DOWNLOAD_ON_THE: 'Скачать из',
          WORKS_WITH: 'Работает с',
          STEP: {
            STEP: 'Шаг',
            ONE: 'Загрузите приложение',
            TWO: 'Добавьте ключ',
            THREE: 'Введите код',
          },
          CONTINUE: 'Продолжить',
          CONFIRM: 'Подтвердить',
          ADD_KEY: 'Добавьте ключ в Google Authenticator и сделайте резервную копию.',
          ADD_KEY_TIP: 'Откройте Google Authenticator, отсканируйте QR-код или введите ключ ниже, чтобы добавить токен подтверждения.',
          SCAN_QR_CODE: 'Отсканируйте QR-код или введите ключ ниже в приложение.',
          CODE_TIP:
            'Сохраните свой ключ на случай возникновения проблем со входом в систему, например, потери телефона или других проблем.',
          COPY: 'Копировать',
          COPIED: 'Скопировано',
          ENTER: 'Введите код из приложения Google Authenticator.',
          ENTER_TIP: 'Откройте приложение GA и введите проверочный код в поле ниже.',
          GA_CODE: 'Код GA',
          ENTER_CODE: 'Введите код',
        },
        PASSWORD: {
          AGO: 'Изменен',
          CURRENT: 'Текущий пароль',
          NEW: 'Новый пароль',
          CONFIRM: 'Подтвердите новый пароль',
          SIGN_OUT: 'Выйти из всех активных учетных записей',
          CHANGE: 'Изменить пароль',
          SUCCESS: 'Пароль успешно изменен!',
          FAIL: 'Не удалось сменить пароль, {{error}}',
        },
        SOCIAL: {
          TITLE: 'Войти через социальные сети',
          DESCRIPTION:
            'Подключите свою учётную запись CAICHAT.AI к аккаунтам социальных сетей для простого и безопасного входа. Вход через социальные сети позволяет обойти двухэтапную аутентификацию и может снизить безопасность вашей учётной записи.',
          CONNECT: 'Подключить',
          DISCONNECT: 'Отключить',
          CONNECTED: 'Подключено',
          NOT_CONNECTED: 'Не подключено',
          NOTIFICATIONS: {
            SUCCESS: 'Учетная запись {{providerName}} успешно отключена',
            FAIL: 'Не удалось отключить учетную запись, {{error}}',
          },
        },
      },
    },
    PAYMENTS: {
      RENEWAL: 'Продление произойдет через {{period}} дней за {{price}}/{{period}} дней. Отменить можно в любое время.',
      SECURE: 'Платежи защищены и зашифрованы',
      TOS_1: 'Нажимая кнопку "Отправить", вы подтверждаете, что вам 18 лет или больше, и вы принимаете',
      TOS_2: 'и',
      TOS_3: '. Мы заботимся о вашей конфиденциальности, поэтому платеж по карте будет отображаться как "{{ brand }}".',
      TOS_4: 'По вопросам оплаты, пожалуйста, свяжитесь с поддержкой по адресу {{ email }}.',
      TOS_5: 'Вы соглашаетесь, что мы сохраним ваши платежные данные, чтобы вам не нужно было вводить их снова в будущем.',
    },
    DELETE_CHAT: {
      TITLE: 'Удалить чат',
      TEXT: 'Вы уверены, что хотите удалить этот чат? После удаления восстановить его будет невозможно.',
      SUCCESS: 'Чат успешно удален!',
      FAIL: 'Не удалось удалить чат!',
    },
    DELETE_PERSONA: {
      TITLE: 'Удалить персонажа',
      TEXT:
        'Удаление этого персонажа приведет к необратимым последствиям — восстановить его будет невозможно.\n' +
        'История общения с ботами останется, и вы сможете продолжить беседу, но от имени другого персонажа.\n' +
        '\n',
      SURE: 'Вы уверены, что хотите удалить этот профиль?',
      WARNING: 'Текущий персонаж по умолчанию не может быть удален.\n' + 'Сначала выберите другого по умолчанию или создайте нового.',
      SUCCESS: 'Персонаж успешно удален!',
      FAIL: 'Не удалось удалить персонажа!',
    },
    DELETE_CHATBOT: {
      TITLE: 'Удалить чат-бота',
      TEXT_1: 'Удаление чат-бота также приведет к удалению всех чатов и изображений. Их невозможно будет восстановить.',
      TEXT_2: 'Вы уверены, что хотите удалить этого чат-бота?',
      SUCCESS: 'Чат-бот успешно удален!',
      FAIL: 'Не удалось удалить чат-бота!',
    },
    BLOCK_CREATOR: {
      TITLE: 'Заблокировать этого автора?',
      TEXT: 'Вы уверены, что хотите заблокировать всех чат-ботов этого автора? Вы сможете разблокировать их в любое время.',
      BLOCK: 'Заблокировать',
    },
    UNBLOCK_CREATOR: {
      TEXT: 'Вы уверены, что хотите разблокировать автора ',
      CANCEL: 'Нет',
      SUCCESS: 'Автор успешно разблокирован!',
      FAIL: 'Не удалось разблокировать автора. Пожалуйста, попробуйте позже.',
    },
    COMPLAIN: {
      TITLE: 'Жалоба',
      MAX_CHECKBOXES: 'Вы можете выбрать максимум 5 чекбоксов',
      CHECKBOX: {
        THREATS: 'Угрозы и домогательства',
        CRUELTY: 'Чрезмерная жестокость',
        FALSE: 'Ложные заявления',
        HATRED: 'Разжигание ненависти',
        NSFW: 'Не для рабочего места (NSFW)',
        HARASSMENT: 'Сексуальные домогательства',
        CHILD_EXPLOIT: 'Эксплуатация детей',
        SELF_HARM: 'Самоповреждения',
        TERRORISM: 'Терроризм и экстремизм',
        ILLEGAL: 'Незаконная деятельность',
        DRUGS: 'Наркоторговля',
        CONFIDENTIALITY: 'Нарушение конфиденциальности',
        IMPERSONATION: 'Самозванство',
        SPAM: 'Коммерческий спам',
      },
    },
    TELL_US_MORE: {
      TITLE: 'Расскажите больше',
      ADDITIONAL_DETAILS: 'Дополнительные детали',
      DETAILS_PLACEHOLDER: 'Опишите проблему подробнее',
      SUCCESS: 'Ваш отзыв успешно отправлен!',
      FAIL: 'Не удалось отправить отзыв. Пожалуйста, попробуйте позже.',
      FUNNY: 'Смешно',
      HEALTHY: 'Полезно',
      FLIRTY: 'Kокетливо',
      INTERESTING: 'Интересно',
      GOOD_MEMORY: 'Хорошая память',
    },
    MODEL_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Модель успешно добавлена в избранное',
        FAIL: 'Не удалось добавить в избранное, попробуйте позже.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Модель успешно удалена из избранного',
        FAIL: 'Не удалось удалить из избранного, попробуйте позже.',
      },
    },
    PROMPTS_CARD_CREATOR: {
      SET_FAVORITE: {
        SUCCESS: 'Промпт успешно добавлен в избранное',
        FAIL: 'Не удалось добавить в избранное, попробуйте позже.',
      },
      UNSET_FAVORITE: {
        SUCCESS: 'Промпт успешно удален из избранного',
        FAIL: 'Не удалось удалить из избранного, попробуйте позже.',
      },
    },
    MEMORIES: {
      TITLE: 'Воспоминания',
      PLACEHOLDER_1: 'Здесь пока нет воспоминаний.',
      PLACEHOLDER_2: 'Продолжите чат с ботом или создайте нового.',
      INPUT_PLACEHOLDER: 'Добавить новое воспоминание...',
      SUBTITLE: 'Добавьте воспоминания о ваших прошлых взаимодействиях с персонажем',
      EDIT: 'Редактировать воспоминание',
      DELETE: 'Удалить воспоминание',
      PIN: 'Закрепить воспоминание',
      UNPIN: 'Открепить воспоминание',
      PINNED: '(Закреплено)',
      EDITED: '(изменено)',
      DELETE_TEXT: 'Вы уверены, что хотите удалить это воспоминание? После удаления восстановить его будет невозможно.',
      MEMORIES_ENABLED: 'Воспоминания успешно включены!',
      MEMORIES_DISABLED: 'Воспоминания успешно отключены!',
      FAILED_TO_UPDATE: 'Не удалось обновить настройки воспоминаний!',
    },
    REGISTRATION: {
      LOGIN_WITH_EMAIL: 'Войти с помощью email',
      CONTINUE: 'Продолжить',
      HAVE_AN_ACCOUNT: 'Уже есть аккаунт?',
      DONT_HAVE_AN_ACCOUNT: 'Нет аккаунта?',
      YOU_AGREE: 'Регистрируясь, вы соглашаетесь с нашими',
      TERMS_AND_CONDITIONS: 'Условиями и положениями',
      YOU_HAVE_READ: 'и вы прочитали нашу',
      PRIVACY_POLICY: 'Политику конфиденциальности',
      FORGOT_PASSWORD: 'Забыли пароль?',
    },
    PASSWORD_RECOVERY: {
      TITLE: 'Восстановить пароль',
      RECOVERY_LINK:
        'Ссылка для восстановления отправлена на вашу почту. Пожалуйста, проверьте почтовый ящик и перейдите по ссылке, чтобы сбросить пароль.',
      ENTER_EMAIL: 'Введите адрес электронной почты, который вы использовали при регистрации, и мы отправим вам инструкции',
      RESET_PASSWORD: 'Сбросить пароль',
    },
    RESET_PASSWORD: {
      ENTER_PASSWORD: 'Введите новый пароль в поля ниже',
      APPLY: 'Применить новый пароль',
      ERROR: 'Неверный URL. Запросите новый сброс пароля.',
    },
    NONEXISTING: {
      TITLE: 'Ой...',
      TEXT: 'То, что вы ищете, может находиться в другом месте или просто не существует. Пожалуйста, попробуйте еще раз.',
    },
    CHOOSE_PERSONA: {
      TITLE: 'Выбрать персонажа',
      SUBTITLE: 'Изменение персонажа во время беседы может нарушить повествование.',
      SUCCESS: 'Персонаж успешно изменен!',
      FAIL: 'Не удалось изменить персонажа!',
    },
    IMPORT_CHATBOT: {
      TITLE: 'Импорт чат-бота',
      DESCRIPTION: 'В настоящее время мы поддерживаем импорт персонажей из spicychat.ai и juicychat.ai.',
      IMPORT_FROM_FILE: {
        TITLE: 'Импорт через JSON или изображение',
        DESCRIPTION: 'Загрузите JSON-файл персонажа или изображение со встроенными данными персонажа.',
        SUPPORTED_LABEL: 'Поддерживаемые форматы:',
        SUPPORTED_FORMATS: 'JSON, PNG, JPG',
        CLICK: 'Нажмите, чтобы выбрать, или перетащите файл сюда',
      },
      IMPORT_FROM_URL: {
        TITLE: 'Импорт по URL',
        ENTER: 'Введите URL-адрес поддерживаемого веб-сайта.',
        CHATBOT_URL: 'URL-адрес чат-бота',
        IMPORT_FROM_URL: 'Импорт из URL',
      },
    },
    BOOSTY_PAYMENT_STATUS: {
      LINK_ACCOUNT: 'Привяжите свой аккаунт Boosty',
      ENTER_EMAIL_DESCRIPTION: 'Для оплаты подписки Boosty, пожалуйста, введите Email, привязанный к вашему аккаунту Boosty ниже',
      EMAIL_WARNING: 'Внимание! Email привязывается к вашему аккаунту CAICHAT и не может быть изменен',
      EMAIL_LABEL: 'Email, привязанный к Boosty',
      EMAIL_PLACEHOLDER: 'Введите ваш Email',
      WHERE_FIND_EMAIL: 'Где найти информацию о моем email на Boosty?',
      INSTRUCTION_STEP_1: 'Нажмите на свой аватар и выберите "Настройки аккаунта" из выпадающего меню',
      INSTRUCTION_STEP_2: 'На вкладке "Профиль" вы найдете свой Email. Просто скопируйте его и вставьте в форму на этой странице',
      HAVE_YOU_PAID: 'Вы оплатили подписку?',
      CONFIRM_PAYMENT_DESCRIPTION:
        'Если вы оплатили подписку Boosty, пожалуйста, подтвердите это ниже. Мы синхронизируем данные для проверки.',
      SYNC_FAILED: 'Синхронизация не удалась. Пожалуйста, проверьте правильность вашего email и успешность оплаты подписки Boosty.',
      CONTACT_SUPPORT: 'Если у вас есть вопросы или необходимо изменить указанный Email, пожалуйста, свяжитесь с поддержкой.',
      RETURN_TO_BOOSTY: 'Вернуться к оплате на Boosty',
      I_HAVE_PAID: 'Я оплатил',
      SUCCESS_PAYMENT: 'Вы успешно оплатили подписку Boosty!',
      CONGRATULATIONS: 'Поздравляем! Теперь вы можете использовать больше функций на CAICHAT.AI. Начните новые чаты прямо сейчас!',
      DATA_SYNCHRONIZED: 'Данные синхронизированы',
      SUBSCRIPTION_VALID_UNTIL: 'Подписка действительна до',
      MY_PREVIOUS_CHATS: 'Мои предыдущие чаты',
      GO_TO_HOMEPAGE: 'Перейти на главную',
      SYNCHRONIZING_DATA: 'Синхронизация данных',
    },
    TOP_UP: {
      TITLE: 'Пополните баланс токенов',
      NOT_ENOUGH: 'У вас недостаточно',
      TOKENS: 'токенов для генерации изображений.',
      TOP_UP_AND: 'Пополните баланс и',
      GENERATE_AMAZING_PHOTOS: 'создавайте потрясающие фотографии',
      RIGHT_IN_THE_CONVERSATION: 'прямо в чате!',
      BUY_TOKENS: 'Купить токены',
    },
  },
  BLOCKS: {
    SORT: {
      MOST_CHATS: 'Больше всего чатов',
      NEWEST: 'Новые',
      OLDEST: 'Старые',
      MOST_POPULAR: 'Самые популярные',
      MOST_LIKED: 'Самые понравившиеся',
    },
    LEFT_SIDEBAR: {
      HOME: 'Главная',
      CHATS: 'Чаты',
      MY_PERSONAS: 'Мои Персоны',
      CREATE_CHATBOT: 'Создать Чатбота',
      MY_CHATBOTS: 'Мои Чатботы',
      FAVORITES: 'Избранное',
      BLOCKED_CREATORS: 'Заблокированные авторы',
      SUBSCRIBE: 'Подписка',
      NOTIFICATIONS: 'Уведомления',
      HELP: 'Помощь',
    },
    RIGHT_SIDEBAR: {
      UPGRADE_PLAN: 'Обновить план',
      GET_PLAN: 'Улучшить подписку',
      ACTIVE: 'Активный',
      DREAMER: 'Мечтатель',
      EXPLORER: 'Исследователь',
      STORY_GOD: 'Бог историй',
      NEW_CHAT: 'Новый чат',
      EXTENSIONS: 'Расширения',
      CREATE_PRESET: 'Создать пресет',
      PERSONAS: 'Персонажи',
      RECENT: 'Недавно использованные ИИ модели',
      PROMPT: 'Промпт',
      NO_MODEL_SELECTED: 'Не выбрана модель для продолжения чата',
      SELECT_MODEL_PROMPT: 'Выберите модель и промпт',
      SELECT_MODEL: 'Выбрать AI-модель',
    },
    CATALOG_FILTER_PANEL: {
      RESET_FILTER: 'Сбросить фильтр',
      SEARCH_TAGS: 'Поиск тегов',
      SHOW: 'Показать',
      CHATBOTS: 'чат-ботов',
    },
    SAFE_SEARCH_TOGGLE: {
      SAFE_SEARCH: 'Безопасный поиск',
    },
    CHATBOT_INFO: {
      TYPE_GREETING_NAME: 'Введите приветствие',
      ADD_NEW_GREETING: 'Добавить новое приветствие',
      GREETINGS: 'Приветствия',
      PERSONALITY: 'Личность',
      SCENARIO: 'Сценарий',
      DIALOG: 'Диалог',
      NOTES: 'Заметка автора',
      DESCRIPTION: 'Описание',
      AVATAR: 'Аватар',
      NAME: 'Имя',
      GREETINGS_PLACEHOLDER:
        'Например: Известный археолог с таинственным прошлым, Элара Найтшейд провела десятилетия, исследуя забытые храмы и древние руины по всему миру. Со своими характерными серебристыми прядями и пронизывающими янтарными глазами, она заслужила уважение в академических кругах, сохраняя при этом ауру загадочности.',
      PERSONALITY_PLACEHOLDER:
        'Опишите личность персонажа, черты характера, прошлое, стиль речи и т.д. Используйте ясный и краткий язык. Примеры: «остроумный и саркастичный», «всегда говорит рифмами», «боится пауков», «бывший детектив, преследуемый прошлым делом».',
      SCENARIO_PLACEHOLDER: 'Опишите сценарий для персонажа. Используйте ясный и краткий язык.',
      DIALOG_PLACEHOLDER:
        "Приведите пример диалога, показывающего, как говорит персонаж. Используйте формат: 'Пользователь: Привет\nПерсонаж: [ответ персонажа]'. Добавьте несколько реплик, чтобы продемонстрировать стиль общения.",
      NOTES_PLACEHOLDER: 'Напишите краткое пояснение для пользователей, как лучше взаимодействовать с этим ботом',
      CHAT_BACKGROUND: 'Фон чата',
      DELETE_CHAT_BACKGROUND: 'Удалить фон чата',
      HIDE_THIS_BLOCK: 'Скрыть этот блок',
    },
    TOKENIZATOR: {
      TOKENS: 'токены',
    },
    BLOCK_BUTTON: {
      NO_BLOCKED: 'У вас нет заблокированных авторов',
      SHARE: 'Поделиться',
      DELETE_CHATBOT: 'Удалить чат-бота',
      EDIT: 'Редактировать',
      BLOCK_CREATOR: 'Заблокировать автора',
      UNBLOCK_CREATOR: 'Разблокировать автора',
      REPORT: 'Пожаловаться на автора',
      REPORT_CHATBOT: 'Пожаловаться на чат-бот',
      VOICE_OVER: 'Озвучка',
      DELETE_IMAGE: 'Удалить изображение',
      REGENERATE_MESSAGE: 'Сгенерировать сообщение заново',
      NEW_CHAT_FROM_HERE: 'Новый чат отсюда',
      BLOCK_SUCCESS: 'Пользователь успешно заблокирован',
      BLOCK_ERROR: 'Не удалось заблокировать пользователя. Попробуйте позже.',
      UNBLOCK_SUCCESS: 'Пользователь успешно разблокирован',
      UNBLOCK_ERROR: 'Не удалось разблокировать пользователя. Попробуйте позже.',
      IMAGE_SETTINGS: 'Настройки изображения',
      RATE_MESSAGE: 'Оценить сообщение',
    },
    CHAT_INPUT: {
      ACTION: 'Действие',
      TYPE_YOUR_MESSAGE: 'Введите сообщение...',
      EDIT_MESSAGE_PLACEHOLDER: 'Редактировать сообщение...',
      DELETED_PERSONA_PLACEHOLDER: 'Ваша персона удалена. Выберите другую.',
      DELETED_PRESET_PLACEHOLDER: 'Модель недоступна. Пожалуйста, выберите другую.',
      SUBSCRIBE_PLACEHOLDER: 'Выбранная AI-модель не доступна с текущей подпиской.',
      SELECT_PERSONA: 'Выбрать персону',
    },
    PRICING_CARD_GROUP: {
      WEEKLY: 'В неделю',
      MONTHLY: 'В месяц',
      YEARLY: 'В год',
      SUBSCRIBE_PLAN: 'Оформить подписку',
      UP_TO: 'До {{percent}}%',
      OFF: 'Скидка {{percent}}%',
    },
    PRICING_CARD: {
      MOST_POPULAR: 'Самый популярный',
      MY_SUBSCRIPTION: 'Моя подписка',
      SUBSCRIBE: 'Подписаться',
      UNSUBSCRIBE: 'Отписаться',
      IN_ADDITION: 'В дополнение к предыдущим уровням:',
      WEEKLY: 'неделя',
      MONTHLY: 'месяц',
      YEARLY: 'год',
    },
    MY_PROFILE_CARD: {
      DATE_OF_BIRTH: 'Дата рождения:',
      REGISTERED: 'Зарегистрирован:',
      SUBSCRIBERS: 'Подписчики',
      LIKES: 'Лайки',
      MY_CHATBOTS: 'Мои чатботы',
      MY_PUBLIC_PAGE: 'Моя публичная страница',
      BALANCE: 'Баланс:',
      ADD_TOKENS: 'Добавить токены',
    },
    CHAT_HEADER: {
      DISCLAIMER:
        'CAICHAT.AI работает на базе ИИ для творческого сторителлинга и ролевых игр. Все беседы вымышленные, не воспринимайте их как реальные факты. Используйте ответственно!',
      SHOW_PREVIOUS: 'Показать предыдущее',
    },
    OVERLAY_INVITE_CODE: {
      TITLE: 'Ваша история начинается здесь!',
      SUBTITLE: 'Остался всего один шаг, чтобы открыть потрясающие возможности и новые миры',
      ENTER_CODE: 'Введите код приглашения',
      INVITE_CODE: 'Код приглашения',
      LETS_GO: 'Поехали!',
      NEED_CODE: 'Нужен код приглашения?',
      JOIN_DISCORD: 'Получить доступ в Discord',
      SIGN_OUT: 'Выйти',
    },

    TOKEN_PACK_CARD: {
      BUY: 'Купить',
      SALE: 'Скидка',
    },

    COMPARE_PLANS_TABLE: {
      MOST_POPULAR: 'Популярно',
      FUNCTION_LIMIT: 'Функция/Лимит',
      INCLUDED_IN_PLAN: 'Включено в план',
      NOT_INCLUDED_IN_PLAN: 'Не включено в план',
      MAIN_FUNCTION: 'ОСНОВНАЯ ФУНКЦИЯ',
      BONUS_FOR_SUB: 'Бонусные токены за подписку (при продлении)',
      UNLIMITED_MESSAGES: 'Безлимитные сообщения',
      COUPON_MONTH: 'Одноразовый купон при подписке на 30 дней',
      COUPON_YEAR: 'Одноразовый купон при годовой подписке',
      USER_IDENTITIES: 'Персоны пользователя',
      USER_IDENTITIES_TOOLTIP:
        'После окончания подписки вы перейдёте на Free plan и не сможете создавать новых персон, пока не освободите место.',
      ABILITY_TO_USE: 'Возможность использовать собственные модели',
      ACCESS_OTHER_EXTENSIONS: 'Доступ к другим и стандартным расширениям',
      AVAILABLE_CONTEXT_TOKENS: 'Доступные токены контекста',
      AVAILABLE_LLM_TOKENS: 'Доступные токены ответа LLM',
      LIMITATION_ON_MODELS: 'ОГРАНИЧЕНИЯ ПО МОДЕЛЯМ',
      AVAILABLE_CHARACTERS: 'Доступные персонажи',
      NO_RESTRICTIONS:
        'Нет ограничений на использование Контекста, Ответов LLM, Персонажей и системных подсказок при использовании собственных моделей, кроме указанных в разделе «Ваши AI модели»',
      CREATE_EXTENSIONS: 'Создавать собственные расширения',
      ADDITIONAL_FEATURES: 'ДОПОЛНИТЕЛЬНЫЕ ФУНКЦИИ',
      SYSTEM_PROMPTS: 'Системные подсказки',
      IMAGE_GEN:
        'Генерация изображений доступна за токены – определённое количество изображений в день бесплатно (ограничение на месяц/неделю)',
      AVATAR_GEN_ALL: 'Генерация аватаров для всех персонажей, включая приватных',
      CHAT_ENCRYPTION: 'Шифрование чата',
      ACCESS_EXTENSIONS: 'Доступ к расширениям',
      ACCESS_MEMORY_MANAGER: 'Доступ к менеджеру памяти (Memories) с возможностью добавлять свои записи',
      SEMANTIC_MEMORY: 'Семантическая память 2.0',
      TTS: 'Текст-в-Речь (озвучка ответов)',
      CREATE_PRIVATE_CHARACTERS: 'Создавать приватных персонажей',
      CREATE_PUBLIC_CHARACTERS: 'Создавать публичных персонажей',
      AD_FREE: 'Без рекламы',
      NO_QUEUE: 'Без очереди',
      ADDITIONAL_TOOLS: 'Дополнительные инструменты для создания персонажей и расширений',
      LIMITED_EDITION_MODEL: 'Модель ограниченного выпуска',
      UP_TO_200: 'до 200',
      UNLIMITED: 'Безлимитно',
      UP_TO_1_PER_DAY: 'До 1 бесплатно в день',
      ONLY_YOUR_OWN_AND_FREE: 'Только свои и бесплатные',
      RECOMMENDED_MODELS_WITHOUT_LIMITATIONS: 'Наши рекомендации без ограничений по токенам',
      UP_TO_5_PER_DAY_PLUS_UNLIMITED_FOR_FEE: 'До 5 в день + безлимит за плату',
      ONLY_SPEECH: 'Только речь',
      UNLIMITED_LOW_QUALITY: 'Безлимит, низкое качество',
      UNLIMITED_MEDIUM_QUALITY: 'Безлимит, среднее качество',
      UNLIMITED_HIGH_QUALITY: 'Безлимит, высокое качество',
      TEN_PERCENT_DISCOUNT_ONE_WEEK: '10% скидка на неделю',
      MONTHLY_COUPON_TEN_PERCENT_DISCOUNT: 'Ежемесячный купон: 10% скидка на токены на неделю',
      TWENTY_PERCENT_DISCOUNT_ONE_WEEK: '20% скидка на неделю',
      MONTHLY_COUPON_TWENTY_PERCENT_DISCOUNT: 'Ежемесячный купон: 20% скидка на токены на неделю',
      THE_ENTIRE_ANSWER: 'Полный ответ',
      THIRTY_PERCENT_DISCOUNT_ONE_WEEK: '30% скидка на неделю',
      MONTHLY_COUPON_THIRTY_PERCENT_DISCOUNT: 'Ежемесячный купон: 30% скидка на токены на неделю',
      AVAILABLE_CHARACTERS_TOOLTIP:
        'Персонажи, на которых потрачено более 2000 токенов на личность и более 3000 токенов на приветствия (учитывается большее значение), не могут использовать бесплатные модели.',
      UP_TO_5k_TOKENS: 'До 5000 токенов, потраченных на личность',
      UP_TO_5k_TOKENS_ACTIVE: 'До 5000 токенов на личность + модели уровня Active',
      UP_TO_5k_TOKENS_DREAMER: 'До 5000 токенов на личность + модели уровня Dreamer',
      UP_TO_5k_TOKENS_CREATOR: 'До 5000 токенов на личность + модели уровня Creator',
      UP_TO_5k_TOKENS_STORY_GOD: 'До 5000 токенов на личность + модели уровня Story GOD',

      ACTIVE: 'Активный',
      FREE_PLAN: 'Бесплатный',
      FREE_MODELS: 'Бесплатные модели',
      FREE_MODELS_FREE: 'Бесплатные модели для персонажей с личностью до 5000 токенов',
      FREE_MODELS_ACTIVE: 'Модели бесплатного плана + модели уровня Активный',
      FREE_MODELS_DREAMER: 'Модели бесплатного плана + модели уровня Мечтатель',
      FREE_MODELS_CREATOR: 'Модели бесплатного плана + модели уровня Создатель',
      FREE_MODELS_STORY_GOD: 'Модели бесплатного плана + модели уровня Бог историй',
    },

    MODEL_PROMPT_PRESET: {
      MODEL: 'Модель',
      DEFAULT: 'По умолчанию',
      RECOMMENDED: 'Рекомендовано',
      PRESET: 'Пресет',
      LAST_USED: 'Недавно',
      SUCCESS: 'Настройки успешно применены!',
      ERROR: 'Не удалось применить настройки!',
      INCOMPATIBLE: 'Несовместимо с моделью ИИ',
      WE_RECOMMEND: 'Мы рекомендуем',
      AUTHORS_CHOICE: 'Выбор автора',
      POPULAR: 'Популярное',
      UNSUITABLE_SUBSCRIPTION: 'Ваш тарифный план не подходит для этой модели.',
    },

    PUBLIC_PROFILE_HEADER: {
      COPIED: 'скопировано',
      SUBSCRIBERS: 'Подписчики',
      LIKES: 'Лайки',
      CHATBOTS: 'Чат-боты',
      YOU_HAVE_BLOCKED_THIS_AUTHOR: 'Вы заблокировали этого автора. ',
      UNBLOCK: 'Разблокировать',
    },
    PROMPTS_BLOCK: {
      REPLACE: 'Заменить ИИ-модель',
      SELECT: 'Выбрать ИИ-модель',
    },
    FILE_UPLOAD: {
      UPLOAD: 'Загрузить',
    },
    SUBSCRIBE_BOOSTY: {
      CAN_SUBSCRIBE: 'Вы также можете оформить подписку через Boosty, который предлагает гибкие варианты для ваших потребностей.',
      HAVE_SUBSCRIBE: 'У вас уже есть подписка через Boosty. Ваша подписка действительна до:',
      GO_TO_BOOSTY: 'Перейти в Boosty',
      SUBSCRIBE_TO_BOOSTY: 'Подписаться на Boosty',
    },
    TAGS_SELECT: {
      TAGS: 'Теги',
      PLACEHOLDER: 'Отметьте вашего персонажа подходящими ключевыми словами (максимум 10 тегов)',
      CREATE_NEW: 'Создать новый – ',
      LIMIT: 'Не более 10 тегов',
      CUSTOM_TAG_VALIDATION: 'Пользовательские теги должны содержать от 3 до 20 символов (только буквенно-цифровые).',
    },
  },
  UTILS: {
    SMART_DATE_FORMAT: {
      JUST_NOW: 'Только что',
      MINUTES_AGO: '{{count}} {{minutes}} назад',
      HOURS_AGO: '{{count}} {{hours}} назад',
      DAYS_AGO: '{{count}} {{days}} назад',
      WEEKS_AGO: '{{count}} {{weeks}} назад',
      MONTHS_AGO: '{{count}} {{months}} назад',
      ONE_MINUTES: 'минуту',
      FEW_MINUTES: 'минуты',
      MANY_MINUTES: 'минут',
      ONE_HOURS: 'час',
      FEW_HOURS: 'часа',
      MANY_HOURS: 'часов',
      ONE_DAYS: 'день',
      FEW_DAYS: 'дня',
      MANY_DAYS: 'дней',
      ONE_WEEK: 'неделю',
      FEW_WEEKS: 'недели',
      MANY_WEEKS: 'недель',
      ONE_MONTH: 'месяц',
      FEW_MONTHS: 'месяца',
      MANY_MONTHS: 'месяцев',
    },
    SMART_MESSAGE_FORMAT: {
      ONE_MESSAGES: 'сообщение',
      FEW_MESSAGES: 'сообщения',
      MANY_MESSAGES: 'сообщений',
    },
    TIME: {
      H: 'ч',
      M: 'м',
      S: 'с',
    },
  },
  NOTIFICATIONS: {
    CHATBOT_CREATE: {
      SUCCESS: 'Чат-бот "{{name}}" успешно создан!',
      UPDATE_SUCCESS: 'Чат-бот успешно обновлен!',
      UPDATE_ERROR: 'Ошибка обновления чат-бота!',
      REQUIRED_FIELDS: 'Обязательные поля должны быть заполнены:',
    },
    CHAT_MESSAGE: {
      NEW_CHAT_STARTED: 'Новый разговор начат с выбранного сообщения!',
      ERROR: 'Произошла ошибка при обработке запроса',
      REPORT_MESSAGE_SENT: 'Ваша жалоба отправлена',
      ENCRYPTION_SAVE: 'Ваши настройки шифрования успешно сохранены.',
      ENCRYPTION_DELETE: 'Шифрование отменено.',
      ENCRYPTION_LIMIT:
        'Вы достигли лимита зашифрованных чатов! Расшифруйте несколько чатов или обновите свой тариф, чтобы продолжить шифровать новые.',
    },
    TEXT_TO_SPEECH_ERROR:
      'Мы не смогли получить доступ к вашему микрофону. Пожалуйста, проверьте разрешения браузера или устройства, чтобы включить преобразование речи в текст.',
    PASSWORD_CHANGED: 'Пароль успешно изменён',
    FAILED_TO_LOAD_IMAGE: 'Не удалось загрузить изображение!',
    COPIED_TO_CLIPBOARD: 'Скопировано в буфер обмена',
  },
  COMMON: {
    ADD: 'Добавить',
    OR: 'или',
    AND: 'и',
    BY: 'от',
    FREE: 'БЕСПЛАТНО',
    EXAMPLE: 'Пример',
    CONTINUE: 'Продолжить',
    CONFIRM: 'Подтвердить',
    SUBMIT: 'Отправить',
    DELETE: 'Удалить',
    DELETED: 'Удалено',
    SAVE: 'Сохранить',
    REGENERATE: 'Сгенерировать снова',
    GENERATE: 'Сгенерировать',
    GENERATING: 'Генерация',
    GENERATION: 'Генерация...',
    CREATE: 'Создать',
    CANCEL: 'Отмена',
    COPY: 'Копировать',
    COPIED: 'Скопировано',
    BACK: 'Назад',
    LOG_IN: 'Войти',
    SIGN_IN: 'Авторизация',
    SIGN_UP: 'Регистрация',
    SIGN_IN_WITH: 'Войти через {{ provider }}',
    PASSWORD: 'Пароль',
    CONFIRM_PASSWORD: 'Подтвердите пароль',
    NOT_AVAILABLE: 'Недоступно',
    CLOSE: 'Закрыть',
    MIN: 'Мин',
    MAX: 'Макс',
    PLACEHOLDER: {
      SEARCH: 'Поиск...',
    },
    FILE_INPUT: {
      INVALID_FILE_TYPE: 'Файл {{fileName}} имеет недопустимый тип. Разрешённые типы: {{allowedTypes}}',
      MAX_FILE_SIZE: 'Файл {{fileName}} превышает максимальный размер {{maxSize}}МБ',
      DRAG_AND_DROP_TO_UPLOAD_IMAGE: 'Перетащите или нажмите, чтобы загрузить изображение',
      DROP_FILE: 'Перетащите файл сюда',
      CHOOSE_FILE: 'Выбрать файл',
    },
    ERROR: {
      INVALID_FIELD: 'Поле недействительно',
      FILLED_IN: 'Поле должно быть заполнено',
      MIN_LENGTH: 'Минимальная длина — {{length}} символов',
      MAX_LENGTH: 'Максимальная длина — {{length}} символов',
      NO_SPACES: 'Поле не может начинаться, заканчиваться или состоять только из пробелов',
      INVALID_EMAIL: 'Неверный адрес электронной почты',
      INVALID_CURRENT_PASSWORD: 'Текущий пароль недействителен',
      PASS_NOT_CHANGED: 'Новый пароль должен отличаться от старого.',
      INVALID_USERNAME: 'Неверное имя пользователя',
      INVALID_USERNAME_EXPANDED:
        'Имя пользователя должно быть от 3 до 20 символов и может содержать только латинские буквы (a–z), цифры и дефисы',
      DUMB_ERROR: 'Что-то пошло не так',
      PASSWORD_MISMATCH: 'Пароли не совпадают.',
      INVALID_PASSWORD:
        'Длина пароля должна быть от {{minLength}} до {{maxLength}} символов. Допустимы только A-Z, a-z, 0-9 и специальные символы.',
      INVALID_EMAIL_OR_PASSWORD: 'Неверная почта или пароль',
      FIELD_BETWEEN: 'Длина должна быть от {{minLength}} до {{maxLength}} символов.',
      PASS_MISMATCH: 'Пароли не совпадают',
      VALUE_MUST_BE_BETWEEN: 'Значение должно быть между {{min}} и {{max}}',
      LOADING_ERROR: 'Ошибка загрузки',
      NOT_ENOUGH_TOKENS: 'У вас недостаточно токенов для генерации изображения. Пожалуйста, пополните свой аккаунт.',
      NO_ITEMS_AVAILABLE: 'Нет доступных элементов',
    },
    MONTH: {
      JANUARY: 'Январь',
      FEBRUARY: 'Февраль',
      MARCH: 'Март',
      APRIL: 'Апрель',
      MAY: 'Май',
      JUNE: 'Июнь',
      JULY: 'Июль',
      AUGUST: 'Август',
      SEPTEMBER: 'Сентябрь',
      OCTOBER: 'Октябрь',
      NOVEMBER: 'Ноябрь',
      DECEMBER: 'Декабрь',
    },
    WEEK: {
      MONDAY: 'Пн',
      TUESDAY: 'Вт',
      WEDNESDAY: 'Ср',
      THURSDAY: 'Чт',
      FRIDAY: 'Пт',
      SATURDAY: 'Сб',
      SUNDAY: 'Вс',
    },
  },
  FAQ: {
    TOPIC1: {
      QUESTION: 'Как работает смена  плана подписки?',
      ANSWER:
        'Смена плана подписки доступна в любой момент: При переходе на уровень выше — активация происходит сразу после оплаты разницы за оставшееся время. При переходе на ниже — активация произойдет после окончания текущего периода.',
    },
    TOPIC2: {
      QUESTION: 'Сгорают ли бонусная энергия после окончания подписки?',
      ANSWER:
        'Нет, бонусная энергия не сгорает — вы можете продолжать использовать ее даже после окончания подписки. Когда вы оформите новую подписку, вам будет начислена новая порция бонусной энергии.',
    },
    TOPIC3: {
      QUESTION: 'Продлевается ли подписка автоматически?',
      ANSWER:
        'Да, подписка продлевается автоматически для вашего удобства, чтобы вы не теряли доступ к функциям. Но вы можете отменить автопродление в любой момент через настройки. При этом доступ к возможностям подписки сохранится до конца оплаченного периода.',
    },
    TOPIC4: {
      QUESTION: 'Остались еще вопросы?',
      ANSWER: 'Если вам нужна помощь, обращайтесь в нашу службу поддержки.',
      BUTTON: 'Задать вопрос',
    },
  },
  FAQ_PROFILE: {
    TOPIC1: {
      QUESTION: 'Могу ли я изменить свой тарифный план (улучшить или понизить)?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC2: {
      QUESTION: 'Как отменить мой тарифный план?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC3: {
      QUESTION: 'Могу ли я отменить подписку, но сохранить преимущества тарифа до конца текущего расчетного периода?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC4: {
      QUESTION: 'Как получить возврат средств?',
      ANSWER: 'Текст будет доступен в ближайшее время. По всем вопросам обращайтесь на почту support@caichat.ai',
    },
    TOPIC5: {
      QUESTION: 'У меня есть дополнительные вопросы.',
      ANSWER: 'Если вам нужна помощь, нажмите кнопку ниже. Наша служба поддержки всегда готова помочь.',
      BUTTON: 'Задать вопрос',
    },
  },
  BACKEND_MESSAGES: {
    INVALID_PASSWORD: 'Неверный пароль',
    SLUG_ALREADY_TAKEN: 'Slug {{ slug }} уже занят другим пользователем',
    TOKENS_EXCEEDED:
      'Выбранная модель недоступна для этого персонажа. Бесплатные модели заблокированы для этого персонажа. Общий контекст ({{number}} токенов) превышает лимит (5000). Пожалуйста, используйте платную модель.',
    NOT_ENOUGH_TOKENS: 'У вас недостаточно токенов для генерации этого изображения',
  },
};
